import { FC, useRef } from "react";
import {
  coin1,
  coin2,
  coin3,
  coin4,
  coin5,
  coin6,
  coin7,
  coin8,
  coin9,
  coin10,
} from "../../common/svg";
import HomeGlobalSVG from "../../common/animation/home-global";
import { Link, useNavigate } from "react-router-dom";
import { useMobile } from "../../utlis";
import { differData } from "../../db/differData";
import Accordion from "../../common/accordion/Accordion";
import { faqContent1, faqContent2 } from "../../constants/FAQ";
// import { NewsletterCTA } from "./newsletterCta";
import DownloadAppSection from "./donwloadSection";
import { NewsletterCTA } from "./newsletterCta";
// import Accordion from "../../common/accordion/Accordion";

const InfiniteScroll = ({ coins }: { coins: string[] }) => {
  const coinContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      ref={coinContainerRef}
      className="bottom-coins w-[400px] xlsm:w-full h-auto shadow-s-thicker rounded-2xl bg-white py-5 px-4 z-20 flex items-center gap-x-3.5 overflow-x-hidden cursor-pointer infinite-scroll"
    >
      {/* Clone the content multiple times for continuous scrolling */}
      <div className="infinite-scroll-content">
        {[...coins, ...coins].map((coin, index) => (
          <span
            key={index}
            className="coins-cont hover:scale-150"
            dangerouslySetInnerHTML={{ __html: coin }}
          />
        ))}
      </div>
    </div>
  );
};

const Home: FC = () => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  const coinArray = [
    coin1,
    coin2,
    coin3,
    coin4,
    coin5,
    coin6,
    coin7,
    coin8,
    coin9,
    coin10,
  ];

  const handleCommunityButtonClick = () => {
    if (typeof window.ml === "function") {
      window.ml("show", "wYcEFq", true);
    } else {
      console.warn('MailerLite form function "ml" is not available.');
    }
  };

  return (
    <div>
      <div className=" relative">
        <section className=" w-full h-full bg-h-bg">
          <div className="">
            <div>
              <div
                className={`relative bg-h-bg py-8 z-10 w-full ${
                  isMobile ? "h-[790px]" : "h-[790px]"
                } `}
                data-bg-color="bg-h-bg"
              >
                <svg
                  className={`absolute ${
                    isMobile
                      ? "left-0 right-0 w-full top-[25.2rem]"
                      : "right-0 w-[81%] top-[15.2rem]"
                  } h-[41%] z-0`}
                  width="1162"
                  height="327"
                  viewBox="0 0 1162 327"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M748.014 139.983C748.014 139.983 800.044 160.106 807.696 162.981C815.348 165.856 826.06 165.035 833.711 164.624C841.363 164.213 950.526 141.626 986.743 118.628C1022.96 95.6304 1117.33 32.3863 1174.46 21.2981C1231.59 10.2098 1324.43 5.69238 1324.43 5.69238H1487.67"
                    stroke="#25245A"
                    strokeWidth="2.46405"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M749.545 150.661C749.545 150.661 763.828 142.858 777.601 142.447C791.374 142.037 805.146 147.786 812.798 150.661C820.45 153.536 833.712 159.696 841.364 159.285C849.015 158.874 937.774 144.911 988.274 135.055C1038.77 125.199 1116.82 95.2196 1183.13 87.8274C1249.45 80.4352 1322.9 80.8459 1322.9 80.8459H1487.67"
                    stroke="#635CFE"
                    strokeWidth="2.46405"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M748.014 162.981C748.014 162.981 767.908 151.893 791.883 150.25C815.858 148.607 860.237 151.071 881.151 152.304C902.066 153.536 906.146 154.768 918.899 155.178C931.652 155.589 1323.92 155.589 1323.92 155.589H1491.75"
                    stroke="#CEB9FF"
                    strokeWidth="2.46405"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M751.074 147.786C751.074 147.786 765.867 160.122 779.64 163.802C793.413 167.483 807.186 162.997 814.837 160.122C822.489 157.247 861.257 153.536 868.909 153.946C876.56 154.357 940.323 159.696 986.743 178.997C1033.16 198.299 1117.33 218.422 1183.64 225.815C1249.96 233.207 1324.94 229.937 1324.94 229.937H1489.71"
                    stroke="#FFD879"
                    strokeWidth="2.46405"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M748.014 172.036C748.014 172.036 800.044 151.913 807.696 149.039C815.348 146.164 823.509 141.599 839.323 142.447C855.136 143.296 950.526 170.394 986.743 193.392C1022.96 216.389 1117.33 279.633 1174.46 290.722C1231.59 301.81 1324.43 306.327 1324.43 306.327H1489.71"
                    stroke="#6ADBFF"
                    strokeWidth="2.46405"
                    strokeMiterlimit="10"
                  />
                  <g clipPath="url(#clip0_167_4912)" className="coin-right">
                    <path
                      d="M1045.01 93C1053.85 93 1061.01 85.8366 1061.01 77C1061.01 68.1634 1053.85 61 1045.01 61C1036.17 61 1029 68.1634 1029 77C1029 85.8366 1036.17 93 1045.01 93Z"
                      fill="#0F8FF8"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1037 80.004L1037.81 78H1038.67C1038.65 77.6571 1038.64 77.3136 1038.64 76.97C1038.64 76.522 1038.66 76.106 1038.69 75.72H1037L1037.81 73.717H1039.09C1040.28 69.906 1042.95 68 1047.11 68C1048.48 68 1049.78 68.177 1051.01 68.532V71.056C1049.85 70.5383 1048.6 70.2738 1047.33 70.28C1044.83 70.28 1043.23 71.426 1042.51 73.718H1049.94L1049.13 75.721H1042.03C1041.99 76.0509 1041.97 76.3834 1041.97 76.716C1041.97 77.195 1041.99 77.623 1042.02 78.001H1048.2L1047.4 80.004H1042.45C1042.98 81.393 1043.63 82.359 1044.4 82.904C1045.16 83.448 1046.26 83.72 1047.67 83.72C1048.69 83.72 1049.8 83.473 1051.01 82.979V85.352C1049.86 85.784 1048.49 86 1046.91 86C1042.74 86 1040.1 84.001 1039 80.004H1037Z"
                      fill="white"
                    />
                  </g>
                  <g clipPath="url(#clip1_167_4912)" className="coin-right">
                    <path
                      d="M994.007 174C1002.85 174 1010.01 166.837 1010.01 158C1010.01 149.163 1002.85 142 994.007 142C985.167 142 978 149.163 978 158C978 166.837 985.167 174 994.007 174Z"
                      fill="#C11A2E"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1000.51 161.154C1000.51 163.724 998.423 165.43 995.341 165.687V168H993.231V165.664C991.146 165.429 989.166 164.629 987.504 163.35L989.057 161.224C990.44 162.299 991.75 163 993.328 163.234V158.654C989.785 157.766 988.135 156.481 988.135 153.841C988.135 151.318 990.197 149.589 993.231 149.355V148H995.341V149.402C996.991 149.585 998.564 150.198 999.904 151.178L998.544 153.374C997.476 152.603 996.385 152.112 995.244 151.879V156.318C998.933 157.206 1000.51 158.631 1000.51 161.154ZM993.327 155.827V151.715C991.799 151.832 990.999 152.65 990.999 153.678C990.999 154.658 991.459 155.29 993.328 155.828L993.327 155.827ZM997.647 161.317C997.647 160.267 997.136 159.636 995.244 159.098V163.328C996.773 163.21 997.647 162.439 997.647 161.318V161.317Z"
                      fill="white"
                    />
                  </g>
                  <g clipPath="url(#clip2_167_4912)" className="coin-right">
                    <path
                      d="M1105 129C1118.25 129 1129 118.255 1129 105C1129 91.7452 1118.25 81 1105 81C1091.75 81 1081 91.7452 1081 105C1081 118.255 1091.75 129 1105 129Z"
                      fill="#26A17B"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1107.88 107.075V107.072C1107.72 107.084 1106.87 107.135 1104.97 107.135C1103.45 107.135 1102.39 107.09 1102.01 107.072V107.077C1096.18 106.82 1091.83 105.805 1091.83 104.59C1091.83 103.376 1096.18 102.361 1102.01 102.1V106.066C1102.39 106.093 1103.49 106.157 1104.99 106.157C1106.81 106.157 1107.71 106.082 1107.88 106.067V102.103C1113.7 102.362 1118.04 103.378 1118.04 104.59C1118.04 105.805 1113.7 106.817 1107.88 107.075ZM1107.88 101.69V98.1415H1116V92.7295H1093.89V98.1415H1102.01V101.689C1095.41 101.992 1090.45 103.3 1090.45 104.866C1090.45 106.432 1095.41 107.738 1102.01 108.043V119.416H1107.88V108.04C1114.47 107.737 1119.42 106.43 1119.42 104.866C1119.42 103.301 1114.47 101.995 1107.88 101.69Z"
                      fill="white"
                    />
                  </g>
                  <g clipPath="url(#clip3_167_4912)" className="coin-right">
                    <path
                      d="M1081 272C1085.75 272 1090.39 270.592 1094.33 267.955C1098.28 265.318 1101.36 261.57 1103.17 257.184C1104.99 252.799 1105.46 247.973 1104.54 243.318C1103.61 238.662 1101.33 234.386 1097.97 231.029C1094.61 227.673 1090.34 225.387 1085.68 224.461C1081.03 223.535 1076.2 224.01 1071.82 225.827C1067.43 227.643 1063.68 230.72 1061.04 234.666C1058.41 238.613 1057 243.253 1057 248C1056.99 251.154 1057.61 254.278 1058.81 257.194C1060.01 260.109 1061.78 262.758 1064.01 264.988C1066.24 267.218 1068.89 268.986 1071.81 270.189C1074.72 271.392 1077.85 272.008 1081 272Z"
                      fill="#2775CA"
                    />
                    <path
                      d="M1087.6 251.801C1087.6 248.31 1085.5 247.099 1081.3 246.6C1078.3 246.2 1077.7 245.4 1077.7 244.001C1077.7 242.603 1078.7 241.699 1080.7 241.699C1082.5 241.699 1083.5 242.299 1084 243.8C1084.05 243.945 1084.15 244.07 1084.28 244.157C1084.4 244.245 1084.55 244.292 1084.71 244.291H1086.31C1086.4 244.294 1086.49 244.277 1086.58 244.243C1086.66 244.209 1086.74 244.157 1086.81 244.092C1086.87 244.026 1086.93 243.948 1086.96 243.862C1086.99 243.776 1087.01 243.684 1087.01 243.591V243.493C1086.81 242.409 1086.27 241.419 1085.46 240.677C1084.64 239.936 1083.61 239.483 1082.51 239.391V236.991C1082.51 236.592 1082.21 236.293 1081.71 236.192H1080.21C1079.81 236.192 1079.51 236.491 1079.41 236.991V239.299C1076.4 239.709 1074.5 241.699 1074.5 244.2C1074.5 247.501 1076.5 248.801 1080.7 249.301C1083.5 249.8 1084.41 250.392 1084.41 252C1084.41 253.608 1083.01 254.701 1081.11 254.701C1078.51 254.701 1077.62 253.61 1077.31 252.1C1077.28 251.931 1077.19 251.778 1077.06 251.667C1076.93 251.556 1076.77 251.493 1076.6 251.491H1074.89C1074.8 251.489 1074.71 251.506 1074.62 251.54C1074.53 251.575 1074.46 251.626 1074.39 251.692C1074.32 251.757 1074.27 251.835 1074.24 251.921C1074.2 252.007 1074.19 252.099 1074.19 252.192V252.292C1074.59 254.792 1076.19 256.592 1079.49 257.092V259.492C1079.49 259.891 1079.79 260.192 1080.29 260.293H1081.79C1082.19 260.293 1082.49 259.992 1082.59 259.492V257.092C1085.59 256.592 1087.59 254.491 1087.59 251.792L1087.6 251.801Z"
                      fill="white"
                    />
                    <path
                      d="M1075.9 262.3C1073.02 261.244 1070.54 259.331 1068.78 256.818C1067.03 254.306 1066.09 251.315 1066.09 248.25C1066.09 245.185 1067.03 242.194 1068.78 239.681C1070.54 237.169 1073.02 235.255 1075.9 234.2C1076.09 234.117 1076.25 233.976 1076.36 233.797C1076.47 233.618 1076.52 233.409 1076.5 233.201V231.8C1076.51 231.616 1076.46 231.434 1076.35 231.287C1076.24 231.139 1076.08 231.037 1075.9 230.999C1075.76 230.985 1075.62 231.02 1075.5 231.1C1071.86 232.257 1068.68 234.542 1066.43 237.626C1064.17 240.709 1062.96 244.43 1062.96 248.25C1062.96 252.07 1064.17 255.791 1066.43 258.874C1068.68 261.957 1071.86 264.243 1075.5 265.4C1075.58 265.448 1075.68 265.476 1075.77 265.482C1075.87 265.487 1075.96 265.469 1076.05 265.43C1076.14 265.391 1076.22 265.332 1076.28 265.257C1076.34 265.183 1076.38 265.095 1076.4 265.001C1076.5 264.9 1076.5 264.8 1076.5 264.599V263.201C1076.5 262.9 1076.2 262.5 1075.9 262.3ZM1086.5 231.1C1086.42 231.051 1086.32 231.024 1086.23 231.018C1086.13 231.013 1086.04 231.031 1085.95 231.07C1085.86 231.109 1085.78 231.169 1085.72 231.244C1085.66 231.319 1085.62 231.407 1085.6 231.501C1085.5 231.599 1085.5 231.7 1085.5 231.9V233.299C1085.52 233.501 1085.58 233.696 1085.68 233.869C1085.79 234.043 1085.93 234.19 1086.1 234.3C1088.98 235.356 1091.46 237.269 1093.22 239.782C1094.97 242.295 1095.91 245.285 1095.91 248.35C1095.91 251.415 1094.97 254.406 1093.22 256.919C1091.46 259.431 1088.98 261.345 1086.1 262.4C1085.91 262.483 1085.75 262.624 1085.64 262.803C1085.53 262.983 1085.48 263.191 1085.5 263.399V264.8C1085.49 264.983 1085.54 265.166 1085.65 265.313C1085.76 265.46 1085.92 265.562 1086.1 265.601C1086.24 265.615 1086.38 265.58 1086.5 265.5C1090.14 264.327 1093.31 262.03 1095.56 258.939C1097.81 255.849 1099.03 252.124 1099.03 248.3C1099.03 244.476 1097.81 240.751 1095.56 237.661C1093.31 234.57 1090.14 232.273 1086.5 231.1Z"
                      fill="white"
                    />
                  </g>
                  <g clipPath="url(#clip4_167_4912)" className="coin-right">
                    <path
                      d="M1051.01 216C1059.85 216 1067.01 208.837 1067.01 200C1067.01 191.163 1059.85 184 1051.01 184C1042.17 184 1035 191.163 1035 200C1035 208.837 1042.17 216 1051.01 216Z"
                      fill="#BC3FE0"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1046.09 198.815V196.483C1046.09 192.807 1048.31 190.5 1052.17 190.5C1055.1 190.5 1056.74 191.742 1058.01 193.34L1055.53 195.24C1054.57 194.075 1053.68 193.39 1052.2 193.39C1050.43 193.39 1049.37 194.607 1049.37 196.56V198.815H1055.95V201.452H1049.37V205.787H1057.96V208.5H1044V206.523L1046.09 205.914V201.452H1044V198.815H1046.09Z"
                      fill="white"
                    />
                  </g>
                  <g filter="url(#filter0_f_167_4912)">
                    <path
                      d="M748.012 172.016C748.012 172.016 695.981 151.893 688.329 149.018C680.678 146.143 669.966 146.964 662.314 147.375C654.662 147.786 545.5 170.373 509.282 193.371C473.065 216.369 378.695 279.613 321.564 290.701C264.432 301.789 171.593 306.307 171.593 306.307H8.35884"
                      stroke="#25245A"
                      strokeWidth="2.46405"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M746.482 161.338C746.482 161.338 732.199 169.141 718.427 169.552C704.654 169.962 690.881 164.213 683.229 161.338C675.578 158.464 662.315 152.303 654.663 152.714C647.012 153.125 558.254 167.088 507.753 176.944C457.253 186.8 379.207 216.779 312.893 224.172C246.579 231.564 173.124 231.153 173.124 231.153H8.35986"
                      stroke="#635CFE"
                      strokeWidth="2.46405"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M748.012 149.018C748.012 149.018 728.118 160.106 704.143 161.749C680.168 163.392 635.789 160.928 614.874 159.696C593.96 158.463 589.879 157.231 577.126 156.821C564.374 156.41 172.103 156.41 172.103 156.41H4.278"
                      stroke="#CEB9FF"
                      strokeWidth="2.46405"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M744.951 164.213C744.951 164.213 730.158 151.877 716.385 148.197C702.612 144.516 688.84 149.002 681.188 151.877C673.536 154.752 634.768 158.463 627.117 158.053C619.465 157.642 555.702 152.303 509.282 133.002C462.863 113.7 378.695 93.5767 312.382 86.1845C246.068 78.7924 171.083 82.0622 171.083 82.0622H6.31851"
                      stroke="#FFD879"
                      strokeWidth="2.46405"
                      strokeMiterlimit="10"
                    />
                    <path
                      d="M748.012 139.963C748.012 139.963 695.981 160.086 688.329 162.96C680.678 165.835 672.516 170.4 656.703 169.552C640.89 168.703 545.5 141.605 509.282 118.608C473.065 95.6097 378.695 32.3656 321.564 21.2774C264.432 10.1891 171.593 5.67169 171.593 5.67169H6.31851"
                      stroke="#6ADBFF"
                      strokeWidth="2.46405"
                      strokeMiterlimit="10"
                    />
                    <g clipPath="url(#clip5_167_4912)" className="coin-left">
                      <path
                        d="M550 191.999C563.255 191.999 574 181.254 574 167.999C574 154.744 563.255 143.999 550 143.999C536.745 143.999 526 154.744 526 167.999C526 181.254 536.745 191.999 550 191.999Z"
                        fill="#26A17B"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M552.882 170.075V170.072C552.717 170.084 551.867 170.135 549.969 170.135C548.454 170.135 547.388 170.09 547.013 170.072V170.076C541.181 169.82 536.828 168.804 536.828 167.589C536.828 166.376 541.181 165.36 547.013 165.099V169.065C547.394 169.092 548.486 169.157 549.995 169.157C551.805 169.157 552.713 169.082 552.882 169.067V165.102C558.702 165.362 563.045 166.377 563.045 167.589C563.045 168.804 558.702 169.817 552.882 170.075ZM552.882 164.69V161.141H561.003V155.729H538.892V161.141H547.013V164.688C540.413 164.991 535.449 166.299 535.449 167.865C535.449 169.431 540.413 170.738 547.013 171.042V182.415H552.882V171.039C559.472 170.736 564.423 169.43 564.423 167.865C564.423 166.301 559.472 164.994 552.882 164.69Z"
                        fill="white"
                      />
                    </g>
                    <g clipPath="url(#clip6_167_4912)" className="coin-left">
                      <path
                        d="M243.999 322.999C248.746 322.999 253.386 321.591 257.333 318.954C261.28 316.317 264.356 312.569 266.172 308.183C267.989 303.798 268.464 298.972 267.538 294.317C266.612 289.661 264.326 285.385 260.97 282.028C257.613 278.672 253.337 276.386 248.681 275.46C244.026 274.534 239.2 275.009 234.815 276.826C230.429 278.642 226.681 281.719 224.044 285.665C221.407 289.612 219.999 294.252 219.999 298.999C219.991 302.153 220.607 305.277 221.81 308.193C223.014 311.108 224.781 313.757 227.011 315.987C229.241 318.217 231.89 319.985 234.806 321.188C237.721 322.391 240.845 323.007 243.999 322.999Z"
                        fill="#2775CA"
                      />
                      <path
                        d="M250.599 302.8C250.599 299.309 248.5 298.098 244.3 297.599C241.298 297.199 240.7 296.399 240.7 295C240.7 293.602 241.699 292.698 243.698 292.698C245.5 292.698 246.499 293.298 246.999 294.799C247.053 294.944 247.15 295.069 247.276 295.156C247.403 295.244 247.554 295.291 247.708 295.29H249.307C249.4 295.293 249.492 295.276 249.578 295.242C249.664 295.208 249.743 295.156 249.808 295.091C249.874 295.025 249.925 294.947 249.959 294.861C249.994 294.775 250.01 294.683 250.008 294.59V294.492C249.815 293.408 249.269 292.418 248.455 291.676C247.642 290.935 246.606 290.482 245.509 290.39V287.99C245.509 287.591 245.208 287.292 244.708 287.191H243.207C242.808 287.191 242.509 287.49 242.409 287.99V290.298C239.4 290.708 237.499 292.698 237.499 295.199C237.499 298.5 239.5 299.8 243.7 300.3C246.499 300.799 247.409 301.391 247.409 302.999C247.409 304.607 246.011 305.7 244.11 305.7C241.51 305.7 240.619 304.609 240.31 303.099C240.281 302.93 240.194 302.777 240.064 302.666C239.934 302.555 239.769 302.493 239.598 302.49H237.89C237.797 302.488 237.705 302.505 237.62 302.539C237.534 302.574 237.456 302.625 237.39 302.691C237.325 302.756 237.273 302.834 237.239 302.92C237.204 303.006 237.188 303.098 237.19 303.191V303.291C237.591 305.791 239.19 307.591 242.491 308.091V310.491C242.491 310.89 242.79 311.191 243.29 311.292H244.791C245.19 311.292 245.491 310.991 245.59 310.491V308.091C248.59 307.591 250.59 305.49 250.59 302.791L250.599 302.8Z"
                        fill="white"
                      />
                      <path
                        d="M238.898 313.299C236.021 312.243 233.537 310.33 231.782 307.817C230.027 305.305 229.086 302.314 229.086 299.249C229.086 296.184 230.027 293.193 231.782 290.681C233.537 288.168 236.021 286.254 238.898 285.199C239.09 285.116 239.251 284.975 239.359 284.796C239.467 284.617 239.516 284.408 239.5 284.2V282.799C239.514 282.615 239.46 282.433 239.349 282.286C239.239 282.138 239.078 282.036 238.898 281.998C238.757 281.984 238.616 282.019 238.499 282.099C234.858 283.256 231.68 285.541 229.425 288.625C227.17 291.708 225.954 295.429 225.954 299.249C225.954 303.069 227.17 306.79 229.425 309.873C231.68 312.956 234.858 315.242 238.499 316.399C238.582 316.447 238.675 316.475 238.771 316.481C238.867 316.486 238.963 316.468 239.051 316.429C239.139 316.39 239.216 316.331 239.277 316.256C239.338 316.182 239.38 316.094 239.4 316C239.5 315.899 239.5 315.799 239.5 315.598V314.2C239.5 313.899 239.199 313.499 238.898 313.299ZM249.499 282.099C249.416 282.05 249.323 282.023 249.226 282.017C249.13 282.012 249.034 282.03 248.946 282.069C248.858 282.108 248.781 282.168 248.72 282.243C248.66 282.318 248.618 282.406 248.598 282.5C248.5 282.598 248.5 282.699 248.5 282.899V284.298C248.517 284.5 248.58 284.695 248.684 284.868C248.788 285.042 248.93 285.189 249.1 285.299C251.977 286.355 254.461 288.268 256.216 290.781C257.971 293.294 258.912 296.284 258.912 299.349C258.912 302.414 257.971 305.405 256.216 307.918C254.461 310.43 251.977 312.344 249.1 313.399C248.908 313.482 248.747 313.623 248.64 313.802C248.532 313.982 248.483 314.19 248.5 314.398V315.799C248.487 315.983 248.54 316.165 248.65 316.312C248.76 316.459 248.92 316.561 249.1 316.6C249.241 316.614 249.382 316.579 249.499 316.499C253.139 315.326 256.312 313.029 258.563 309.938C260.814 306.848 262.027 303.123 262.027 299.299C262.027 295.476 260.814 291.75 258.563 288.66C256.312 285.569 253.139 283.272 249.499 282.099Z"
                        fill="white"
                      />
                    </g>
                    <g clipPath="url(#clip7_167_4912)" className="coin-left">
                      <path
                        d="M477.004 171.999C485.845 171.999 493.012 164.836 493.012 155.999C493.012 147.162 485.845 139.999 477.004 139.999C468.164 139.999 460.997 147.162 460.997 155.999C460.997 164.836 468.164 171.999 477.004 171.999Z"
                        fill="#BC3FE0"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M472.09 154.814V152.482C472.09 148.806 474.31 146.499 478.168 146.499C481.101 146.499 482.74 147.741 484.008 149.339L481.524 151.239C480.573 150.074 479.673 149.389 478.195 149.389C476.424 149.389 475.366 150.606 475.366 152.559V154.814H481.947V157.451H475.366V161.786H483.955V164.499H470.002V162.522L472.09 161.913V157.451H470.002V154.814H472.09Z"
                        fill="white"
                      />
                    </g>
                    <g clipPath="url(#clip8_167_4912)" className="coin-left">
                      <path
                        d="M402.004 68.999C410.845 68.999 418.012 61.8356 418.012 52.999C418.012 44.1625 410.845 36.999 402.004 36.999C393.164 36.999 385.997 44.1625 385.997 52.999C385.997 61.8356 393.164 68.999 402.004 68.999Z"
                        fill="#C11A2E"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M408.508 56.153C408.508 58.723 406.421 60.429 403.34 60.686V62.999H401.229V60.663C399.144 60.4281 397.164 59.6279 395.502 58.349L397.055 56.223C398.438 57.298 399.748 57.999 401.326 58.233V53.653C397.783 52.765 396.133 51.48 396.133 48.84C396.133 46.317 398.195 44.588 401.229 44.354V42.999H403.34V44.401C404.989 44.5842 406.562 45.1966 407.902 46.177L406.542 48.373C405.475 47.602 404.383 47.111 403.242 46.878V51.317C406.931 52.205 408.508 53.63 408.508 56.153ZM401.325 50.826V46.714C399.797 46.831 398.997 47.649 398.997 48.677C398.997 49.657 399.457 50.289 401.326 50.827L401.325 50.826ZM405.645 56.316C405.645 55.266 405.134 54.635 403.242 54.097V58.327C404.771 58.209 405.645 57.438 405.645 56.317V56.316Z"
                        fill="white"
                      />
                    </g>
                    <g clipPath="url(#clip9_167_4912)" className="coin-left">
                      <path
                        d="M407.004 118.999C415.845 118.999 423.012 111.836 423.012 102.999C423.012 94.1625 415.845 86.999 407.004 86.999C398.164 86.999 390.997 94.1625 390.997 102.999C390.997 111.836 398.164 118.999 407.004 118.999Z"
                        fill="#0F8FF8"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M399.001 106.003L399.811 103.999H400.669C400.647 103.656 400.635 103.313 400.635 102.969C400.635 102.521 400.654 102.105 400.691 101.719H399.001L399.811 99.716H401.086C402.272 95.905 404.948 93.999 409.109 93.999C410.476 93.999 411.776 94.176 413.007 94.531V97.055C411.848 96.5373 410.592 96.2728 409.323 96.279C406.829 96.279 405.225 97.425 404.51 99.717H411.937L411.127 101.72H404.026C403.984 102.05 403.965 102.382 403.97 102.715C403.97 103.194 403.985 103.622 404.015 104H410.201L409.401 106.003H404.443C404.977 107.392 405.627 108.358 406.393 108.903C407.159 109.447 408.252 109.719 409.672 109.719C410.686 109.719 411.798 109.472 413.007 108.978V111.351C411.858 111.783 410.491 111.999 408.906 111.999C404.737 111.999 402.099 110 400.996 106.003H399.001Z"
                        fill="white"
                      />
                    </g>
                  </g>
                  <g filter="url(#filter1_b_167_4912)" className="coin-center">
                    <rect
                      x="655.219"
                      y="32.5225"
                      width="247.776"
                      height="247.776"
                      rx="15.0167"
                      fill="#1570EF"
                      fillOpacity="0.04"
                    />
                  </g>
                  <g filter="url(#filter2_dd_167_4912)" className="coin-center">
                    <path
                      d="M757.977 103.322C754.485 103.943 750.8 105.514 747.89 107.609C746.106 108.89 743.293 111.741 742.168 113.39C740.888 115.291 724.07 144.466 723.177 146.367C721.451 149.994 720.869 153.098 721.024 157.676C721.121 160.993 721.528 162.952 722.692 165.958C723.313 167.588 740.849 198.14 742.42 200.332C745.776 205.026 751.227 208.537 757.395 209.934C759.257 210.36 759.529 210.36 777.608 210.438C789.751 210.477 796.676 210.438 798.111 210.302C802.107 209.914 805.735 208.692 809.168 206.578C811.127 205.356 814.949 201.709 816.152 199.905C817.917 197.267 834.948 167.588 835.569 166.094C836.752 163.165 837.198 161.07 837.295 157.676C837.45 153.098 836.869 149.994 835.142 146.367C833.998 143.922 816.947 114.438 815.802 112.905C812.117 107.939 806.317 104.37 800.168 103.303C797.801 102.896 760.266 102.896 757.977 103.322ZM808.063 119.442C808.063 119.5 806.841 123.147 805.347 127.531C803.853 131.915 802.631 135.62 802.631 135.736C802.631 135.969 801.681 136.241 798.461 136.862C797.18 137.114 793.34 137.909 789.926 138.607C773.34 142.021 769.441 142.817 767.909 143.088C765.213 143.573 762.4 144.175 762.128 144.31C761.934 144.427 762.594 145.3 764.417 147.453C765.814 149.102 767.463 151.041 768.064 151.798C769.693 153.796 771.09 155.425 773.146 157.714C774.155 158.839 775.435 160.275 775.959 160.896C776.502 161.516 777.375 162.525 777.899 163.126C779.839 165.26 780.556 166.249 780.285 166.327C779.625 166.521 777.026 167.025 776.25 167.122C775.455 167.239 772.7 167.801 766.92 169.062C763.506 169.799 763.331 169.78 762.186 168.422C761.643 167.782 760.169 166.075 758.889 164.601C757.609 163.126 756.173 161.458 755.688 160.896C752.604 157.307 750.199 154.63 749.985 154.552C749.869 154.494 749.326 153.835 748.821 153.059C747.114 150.518 745.989 146.347 746.28 143.67C746.765 139.306 748.414 135.814 751.246 133.195C753.923 130.712 756.076 129.742 761.217 128.734C764.766 128.035 777.162 125.514 781.39 124.621C782.671 124.35 784.339 124.02 785.076 123.884C785.833 123.729 787.52 123.38 788.859 123.089C790.197 122.817 792.37 122.371 793.708 122.119C795.047 121.848 798.674 121.13 801.758 120.49C807.616 119.306 808.063 119.229 808.063 119.442ZM796.23 144.95C796.851 145.629 798.17 147.104 799.159 148.229C800.168 149.354 801.506 150.867 802.146 151.585C802.786 152.302 803.388 153.059 803.485 153.272C803.582 153.466 803.717 153.641 803.814 153.641C803.892 153.641 804.649 154.436 805.483 155.425C806.317 156.415 807.403 157.656 807.888 158.199C808.955 159.383 810.061 161.031 810.701 162.428C812.117 165.57 812.427 169.663 811.457 172.922C810.352 176.705 808.276 179.673 805.308 181.71C802.709 183.514 802.204 183.649 791.089 185.919C787.675 186.617 782.128 187.762 778.772 188.441C775.416 189.139 769.868 190.264 766.454 190.962C763.04 191.68 757.997 192.708 755.261 193.271C752.507 193.833 750.257 194.241 750.257 194.144C750.257 193.911 755.649 178.024 755.843 177.714C755.999 177.442 756.522 177.326 762.283 176.142C763.835 175.832 767.463 175.095 770.334 174.494C773.224 173.892 776.619 173.194 777.899 172.942C779.179 172.69 782.36 172.03 784.979 171.487C787.598 170.944 790.643 170.323 791.768 170.129C794.542 169.605 796.618 169.101 796.618 168.907C796.618 168.829 795.59 167.607 794.329 166.191C793.087 164.795 791.633 163.068 791.109 162.37C790.585 161.671 789.654 160.585 789.072 159.945C788.471 159.305 787.423 158.122 786.725 157.326C786.027 156.531 785.057 155.445 784.572 154.902C784.087 154.378 782.477 152.535 780.983 150.828C779.509 149.121 778.151 147.627 777.996 147.492C777.744 147.298 777.744 147.259 777.996 147.181C779.218 146.813 786.104 145.241 787.986 144.912C789.266 144.679 791.051 144.349 791.962 144.136C794.775 143.515 794.93 143.554 796.23 144.95Z"
                      fill="#9CBBE7"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_167_4912"
                      x="0.27832"
                      y="0.439453"
                      width="752.333"
                      height="326.56"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="2"
                        result="effect1_foregroundBlur_167_4912"
                      />
                    </filter>
                    <filter
                      id="filter1_b_167_4912"
                      x="640.202"
                      y="17.5057"
                      width="277.811"
                      height="277.81"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feGaussianBlur
                        in="BackgroundImageFix"
                        stdDeviation="7.50837"
                      />
                      <feComposite
                        in2="SourceAlpha"
                        operator="in"
                        result="effect1_backgroundBlur_167_4912"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_backgroundBlur_167_4912"
                        result="shape"
                      />
                    </filter>
                    <filter
                      id="filter2_dd_167_4912"
                      x="710.095"
                      y="95.73"
                      width="138.128"
                      height="129.262"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="3.63498" />
                      <feGaussianBlur stdDeviation="3.63498" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_167_4912"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="3.63498" />
                      <feGaussianBlur stdDeviation="5.45247" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_167_4912"
                        result="effect2_dropShadow_167_4912"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_167_4912"
                        result="shape"
                      />
                    </filter>
                    <clipPath id="clip0_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(1029 61)"
                      />
                    </clipPath>
                    <clipPath id="clip1_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(978 142)"
                      />
                    </clipPath>
                    <clipPath id="clip2_167_4912">
                      <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(1081 81)"
                      />
                    </clipPath>
                    <clipPath id="clip3_167_4912">
                      <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(1057 224)"
                      />
                    </clipPath>
                    <clipPath id="clip4_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(1035 184)"
                      />
                    </clipPath>
                    <clipPath id="clip5_167_4912">
                      <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(526 143.999)"
                      />
                    </clipPath>
                    <clipPath id="clip6_167_4912">
                      <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(219.999 274.999)"
                      />
                    </clipPath>
                    <clipPath id="clip7_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(460.997 139.999)"
                      />
                    </clipPath>
                    <clipPath id="clip8_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(385.997 36.999)"
                      />
                    </clipPath>
                    <clipPath id="clip9_167_4912">
                      <rect
                        width="32.0146"
                        height="32"
                        fill="white"
                        transform="translate(390.997 86.999)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div className="absolute z-20 w-full">
                  <div className="max-content">
                    <div className="container">
                      <div
                        className={` ${
                          isMobile
                            ? "w-full mt-[6rem] text-center"
                            : " w-[790px] mt-[9rem]"
                        }  flex flex-col justify-center`}
                      >
                        <h6
                          className={`text-hgray-300 mdxl:mt-[30px] xlsm:mt-[20px] ${
                            isMobile
                              ? "text-[13px] font-satoshi font-medium"
                              : "text-[12.5px] font-roobert font-bold"
                          }`}
                        >
                          PAYMENTS, SWAPS, DEPOSITS
                        </h6>
                        <h1
                          className={`home-text text-white text-[60px] font-satoshi font-black leading-[62px] mt-[24px] xlsm:text-[24px] xlsm:leading-[38px] xlsm:mt-[20px] `}
                        >
                          Access blockchain-powered finance anywhere, anytime.
                        </h1>
                        <p
                          className={`text-hgray-300 ${
                            isMobile ? "text-[15.5px]" : "text-[17.5px]"
                          } font-inter font-normal mt-[24px]`}
                        >
                          We are bridging the gap between traditional finance
                          and the blockchain, making it simple to leverage the
                          benefits that decentralised finance brings.
                        </p>
                        <a href="https://business.shiga.io/signup">
                          <button
                            className={`mt-[24px] ${
                              isMobile ? "mx-auto w-[195px]" : "w-[250px]"
                            } py-[13px] text-[14.5px] text-white font-ibm font-semibold rounded-[7px] border border-hbrand-600 bg-hbrand-600 hover:bg-hbrand-700 hover:border-hbrand-700 shadow-s-light`}
                          >
                            Get started
                          </button>
                        </a>

                        <div
                          className={`flex flex-col items-start mt-[54px] lg:mt-[160px] xlsm:mt-[220px]`}
                        >
                          <p
                            className={`text-hgray-400  ${
                              isMobile ? "text-[15px]" : "text-[13.9px]"
                            } font-roobert font-normal`}
                          >
                            Backed by
                          </p>
                          <div className="flex items-center gap-[47px]">
                            <img
                              className={`w-[88px] h-[40px] mt-[16px]`}
                              src="/assets/tetherGray.svg"
                              alt="Tether"
                            />
                            <img
                              className={` w-[88px] h-[30px] mt-[16px]`}
                              src="/assets/dfs.svg"
                              alt="DFS Labs"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full h-full bg-white">
          <div className="max-content ">
            <div className="container">
              <div className=" relative bg-white">
                <div
                  className={` pb-[24px] xlsm:px-0 ${
                    isMobile ? "pt-[55px] px-[31px]" : "pt-[88px]"
                  } text-center`}
                >
                  <h2
                    className={`top-text font-satoshi font-black text-hgray-950 text-[43.5px] ${
                      isMobile ? "leading-[38px]" : ""
                    }`}
                  >
                    The blockchain solutions you need
                  </h2>
                  <p
                    className={`font-ibm font-normal text-[#12141D] mt-5 ${
                      isMobile ? "text-[17px]" : "text-[16.5px]"
                    }`}
                  >
                    Explore simple ways to use the blockchain to your financial
                    advantage.
                  </p>
                </div>

                <div
                  className={`py-[88px] xlsm:py-[60px] flex items-center justify-between mdxl:gap-[40px] mdxl:flex-col-reverse`}
                >
                  <div
                    className={` relative h-[475px] mdxl:w-[100%] w-[46%] xlsm:h-[490px] `}
                  >
                    <img
                      src="/BrandPatternGreen.svg"
                      alt=""
                      className="h-[462px] w-[488px] absolute -bottom-[29px] -right-[28px] xlsm:-bottom-[50px] z-0"
                    />
                    <div className="bg-[#F4F4F4] rounded-[40px] h-[475px] w-[100%] absolute top-0 z-1">
                      <div className="flex flex-col justify-center items-center h-full w-full">
                        <img
                          className={` z-10 w-[362px] mdxl:w-full h-[329px] -mb-5`}
                          src="/assets/calcB.svg"
                          alt="Rates Calculator"
                        />
                        <InfiniteScroll coins={coinArray} />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`bottom-right relative mdxl:w-full ${
                      isMobile ? "w-full" : "w-[47%]"
                    } flex flex-col justify-center`}
                  >
                    <p className="font-ibm font-medium text-[10.5px] w-fit px-1.5 py-0.5 rounded-2xl text-hsuccess-700 bg-hsuccess-50 border border-hsuccess-200">
                      PORTAL IN/OUT
                    </p>
                    <h3
                      className={`solu-header mt-3.5 font-satoshi font-black text-[44.5px] text-hgray-950 ${
                        isMobile ? "leading-[39px] pr-[18px]" : "leading-[55px]"
                      }`}
                    >
                      Your Wallet, Now with Bank Account Features
                    </h3>
                    <p
                      className={`mt-6 font-ibm font-normal text-[16.5px] text-[#12141D] ${
                        isMobile ? "w-full" : "w-full "
                      }`}
                    >
                      Exchange, buy, sell, and transfer multichain stablecoins
                      seamlessly into local fiat currencies. All powered by the
                      security and efficiency of blockchain.
                    </p>
                    <div className="right-btn mt-[40px] flex items-center gap-x-9 font-ibm font-semibold text-[14.5px]">
                      <button
                        onClick={() => navigate("/portal-in-and-out")}
                        className={`w-[190px] ${
                          isMobile ? "py-2.5" : "py-3"
                        } px-3.5 rounded-lg border border-hbrand-600 bg-hbrand-600 hover:bg-hbrand-700 hover:border-hbrand-700 shadow-s-light text-white`}
                      >
                        Start swapping now
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className={` relative flex mdxl:flex-col items-center gap-[40px] py-[88px] xlsm:py-[60px] justify-between ${
                    isMobile ? "pt-[30px] pb-[26px] px-[24px] flex-col" : ""
                  } `}
                >
                  <div
                    className={`bottom-right w-[47%] flex flex-col justify-center relative mdxl:w-full`}
                  >
                    <p className="font-ibm font-medium text-[10.5px] w-fit py-0.5 px-1.5 rounded-2xl text-horange-700 bg-horange-50 border border-horange-200">
                      PAYMENTS
                    </p>
                    <h3
                      className={`solu-header mt-3.5 font-satoshi font-black text-[44.5px] text-hgray-950 ${
                        isMobile ? "leading-[39px] pr-[18px]" : "leading-[55px]"
                      }`}
                    >
                      Shiga STS: Tailored for High-Volume Trades
                    </h3>
                    <p
                      className={`mt-6 font-ibm font-normal text-[16.5px] text-[#12141D] ${
                        isMobile ? "w-full" : ""
                      }`}
                    >
                      Leverage our multichain and multicurrency rails for
                      large-scale trades. Get personalized support from a
                      dedicated account manager.
                    </p>
                    <div className="right-btn mt-[40px] flex items-center gap-x-9 font-ibm font-semibold text-[14.5px]">
                      <button
                        onClick={() =>
                          navigate("/shiga-otc-tailored-for-high-volume-trades")
                        }
                        className={`w-[190px] ${
                          isMobile ? "py-2.5" : "py-3"
                        } px-3.5 rounded-lg border border-hbrand-600 bg-hbrand-600 hover:bg-hbrand-700 hover:border-hbrand-700 shadow-s-light text-white`}
                      >
                        Explore STS services
                      </button>
                    </div>
                  </div>

                  <div
                    className={`relative h-[475px] xlsm:h-[380px] mdxl:w-[100%] w-[46%] `}
                  >
                    <img
                      src="/brandPatternOrange.png"
                      alt=""
                      className="h-[462px] w-[488px] xlsm:h-[380px] absolute -bottom-[29px] -left-[28px] z-0"
                    />
                    <div className="bg-[#F4F4F4] rounded-[40px] h-[475px] xlsm:h-[380px] w-[100%] absolute top-0 z-1">
                      <div className="flex flex-col justify-center mdxl:px-[20px] items-center h-full w-full">
                        <img
                          className={` z-10 w-[362px] mdxl:w-full h-[329px]`}
                          src="/assets/orangeB.svg"
                          alt="Rates Calculator"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`busi-bottom relative flex items-center justify-between mdxl:flex-col-reverse mdxl:gap-[40px] py-[88px] xlsm:py-[60px] ${
                    isMobile ? "pt-[30px] pb-[26px] px-[24px] " : " "
                  } `}
                >
                  <div
                    className={`relative h-[475px] xlsm:h-[380px] mdxl:w-[100%] w-[46%] `}
                  >
                    <img
                      src="/brandPatternBlue.png"
                      alt=""
                      className="h-[462px] w-[488px] xlsm:h-[380px] absolute -bottom-[29px] -right-[28px] z-0"
                    />
                    <div className="bg-[#F4F4F4] rounded-[40px] h-[475px] xlsm:h-[380px] w-[100%] absolute top-0 z-1">
                      <div className="flex flex-col justify-center mdxl:px-[20px] items-center h-full w-full">
                        <img
                          className={` z-10 w-[362px] mdxl:w-full h-[400px] hover:scale-105`}
                          src="/assets/home-busi.svg"
                          alt="Business World Wide"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={`bottom-right relative w-[47%] mdxl:w-full flex flex-col justify-center`}
                  >
                    <p className="font-ibm font-medium text-[10.5px] w-fit px-1.5 py-0.5 rounded-2xl text-hbrand-700 bg-hbrand-50 border border-hbrand-200">
                      BUSINESS
                    </p>
                    <h3
                      className={`solu-header mt-3.5 font-satoshi font-black text-[44.5px] text-hgray-950 ${
                        isMobile ? "leading-[39px] pr-[18px]" : "leading-[55px]"
                      }`}
                    >
                      Blockchain Finance for Global Enterprises
                    </h3>
                    <p
                      className={`mt-6 font-ibm font-normal text-[16.5px] text-[#12141D]`}
                    >
                      Empower your business with decentralized banking
                      solutions. Own your wallets and access real-world
                      blockchain finance, tailored for global companies with
                      dedicated support for Pan-African trade.
                    </p>
                    <div className="right-btn mt-[40px] flex items-center gap-x-9 font-ibm font-semibold text-[14.5px]">
                      <button
                        onClick={() =>
                          navigate("/blockchain-finance-for-global-enterprises")
                        }
                        className={`w-[220px] ${
                          isMobile ? "py-2.5" : "py-3"
                        } px-3.5 rounded-lg border border-hbrand-600 bg-hbrand-600 hover:bg-hbrand-700 hover:border-hbrand-700 shadow-s-light text-white`}
                      >
                        Explore business solutions
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" relative bg-white">
                <div
                  className={`global-top text-center pt-[88px] pb-[24px] xlsm:pt-[56px] xlsm:pb-[18px]`}
                >
                  <h2
                    className={`global-header font-satoshi font-black text-hgray-950 text-[43.5px] sixm:leading-[38px]`}
                  >
                    Global coverage you can count on
                  </h2>
                </div>

                <div
                  className={`global-middle ${
                    isMobile ? " pt-[10px] pb-[40px]" : " pt-[10px] pb-[98px]"
                  }`}
                >
                  <HomeGlobalSVG />
                </div>
              </div>
            </div>
          </div>
        </section>

        <DownloadAppSection />

        <section className=" w-full h-full bg-hbrand-25">
          <div className="max-content">
            <div className="container">
              <div className=" relative bg-hbrand-25">
                <div
                  className={`pt-[98px] pb-[120px] xlsm:pt-[65px] xlsm:pb-[49px]`}
                >
                  <h2
                    className={`built-header font-satoshi font-black text-hgray-950 text-[43.5px] text-center ${
                      isMobile ? "leading-[38px]" : ""
                    }`}
                  >
                    Built on Trust and Security
                  </h2>

                  <div
                    className={`flex mt-[58px] lg:flex-col lg:mt-[46px] lg:gap-[40px]  items-center justify-center`}
                  >
                    <div
                      className={`w-[50%] sixm:pb-8 sixm:w-full sixm:border-b-[0.25px] sixm:border-b-hgray-200 lg:border-r-0  border-r-[0.25px] border-r-hgray-200 flex flex-col items-center justify-center gap-y-3`}
                    >
                      <p className="font-ibm font-medium text-[12px] text-center text-hgray-700 border border-hgray-200 bg-hgray-50 rounded-2xl px-2 py-0.5">
                        BACKED BY
                      </p>
                      <p
                        className={`font-ibm font-normal w-[430px] text-center text-[#12141D] ${
                          isMobile
                            ? "w-full text-[16.5px]"
                            : "w-[430px] text-[15.8px]"
                        }`}
                      >
                        Shiga partners with licensed financial institutions
                        globally and offers decentralized solutions that ensure
                        security and trust.
                      </p>
                      <div className="flex items-center gap-[47px]">
                        <img
                          className={`w-[88px] mt-[16px]`}
                          src="/assets/tetherGray.svg"
                          alt="Tether"
                        />
                        <img
                          className={` w-[88px] mt-[16px]`}
                          src="/assets/dfs.svg"
                          alt="DFS Labs"
                        />
                      </div>
                    </div>

                    <div
                      className={` w-[50%] sixm:pt-2 sixm:w-full sixm:border-t-0 lg:border-l-0 sixm:border-b-hgray-200 border-l-[0.25px] border-l-hgray-200 flex flex-col items-center justify-center gap-y-4`}
                    >
                      <p className="font-ibm font-medium text-[12px] text-center text-hgray-700 border border-hgray-200 bg-hgray-50 rounded-2xl px-2 py-0.5">
                        LICENSES
                      </p>
                      <p
                        className={`font-ibm font-normal text-center text-[#12141D] ${
                          isMobile
                            ? "w-full text-[16.5px]"
                            : "w-[430px] text-[15.8px]"
                        }`}
                      >
                        Shiga is registered as a Virtual Assets Service Provider
                        (VASP) Licensed in the European Union.
                      </p>
                      <img
                        className="w-[45px] mt-[16px]"
                        src="/assets/eu.svg"
                        alt="Europe"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" w-full h-full bg-[#12141D]">
          <div className="max-content">
            <div className="container">
              <div className="bg-[#12141D]">
                <div className={`built-cont py-[120px] mdxl:py-[70px]"`}>
                  <h2
                    className={`differ-header font-satoshi font-black text-white text-[43.5px] text-center ${
                      isMobile ? "leading-[38px]" : ""
                    }`}
                  >
                    Here is how we differ from the rest
                  </h2>

                  <div className="mt-[80px] grid grid-cols-3 gap-[64px] lg:grid-cols-2 sixm:justify-center sixm:flex sixm:flex-wrap sixm:gap-[40px]">
                    {differData?.map((item, index) => (
                      <div key={index} className=" sm:w-full">
                        <div className="flex sixm:justify-center items-center gap-[8px]">
                          <img
                            src={item?.icon}
                            alt="iconn"
                            className="w-[32px] w-[32px]"
                          />
                          <p className="font-[900] font-satoshi text-[20px] sixm:text-[18px] text-white leading-[27px] sixm:leading-[24px]">
                            {item?.title}
                          </p>
                        </div>
                        <p className="mt-[24px] sixm:text-center font-[400] font-ibm text-[18px] leading-[28px] text-[#D0D5DD]">
                          {item?.subtitle}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=" w-full h-full bg-white">
          <div className="max-content">
            <div className="container">
              <div className=" relative bg-white">
                <div
                  className={`flex flex-col items-center ${
                    isMobile ? "w-full pt-[60px] pb-[66px]" : " py-[80px]"
                  }`}
                >
                  <p className="font-ibm font-medium text-[12px] text-center text-hgray-700 border border-hgray-200 bg-hgray-50 rounded-2xl px-2 py-0.5 w-fit">
                    HEAR FROM SHIGA CUSTOMERS
                  </p>

                  <div
                    className={`${
                      isMobile ? "w-[91%] mt-[35px]" : "w-[760px] mt-[40px]"
                    }`}
                  >
                    <h2
                      className={`hear-text font-satoshi font-black text-hgray-950 w-full text-[43.5px] gap-x-3 text-center flex flex-wrap justify-center ${
                        isMobile ? "items-end text-center" : "items-center"
                      }`}
                    >
                      Preferred by <p className="xlsm:hidden">individuals</p>
                      <div className="tool-cont relative flex flex-col items-center">
                        <div className="flex gap-1">
                          <p className="xlsm:block hidden">individuals</p>
                          <img
                            className={`cursor-pointer ${
                              isMobile ? "w-[62px]" : "w-[72px]"
                            }`}
                            src="/assets/user1.svg"
                            alt="first user"
                          />
                        </div>
                        <span
                          className={`tooltip-text absolute left-1/2 transform -bottom-12 text-white text-[12.5px] font-normal font-ibm rounded ${
                            isMobile
                              ? "px-1 -translate-x-[58%]"
                              : "px-2 -translate-x-1/2"
                          } py-1 opacity-0 transition-opacity duration-300 pointer-events-none`}
                        >
                          In a foreign exchange market (formerly) dominated by
                          shady and untraceable dealers, Shiga has been a breath
                          of fresh air. SUPER-quick, reliable and traceable
                          payments from a single legitimate source.
                        </span>
                      </div>
                      <p>and </p>
                      <p className={`${isMobile ? "" : "-ml-[111px]"}`}>
                        {" "}
                        businesses
                      </p>
                      <div className="tool-cont relative flex flex-col items-center">
                        <img
                          className={`cursor-pointer ${
                            isMobile ? "w-[62px]" : "w-[72px]"
                          }`}
                          src="/assets/user2.svg"
                          alt="second user"
                        />
                        <span
                          className={`tooltip-text absolute left-1/2 transform -bottom-12 text-white text-[12.5px] font-normal font-ibm rounded ${
                            isMobile
                              ? "px-1 -translate-x-[84%]"
                              : "px-2 -translate-x-1/2"
                          } py-1 opacity-0 transition-opacity duration-300 pointer-events-none`}
                        >
                          Shiga has been great at supporting our operational FX
                          needs, including payroll, servicing our events, and
                          more. The process is swift, reliable and smooth.
                        </span>
                      </div>
                      <p>that</p> <p>care </p> <p>about </p> <p>their </p>
                    </h2>

                    <h2 className="hear-text font-satoshi font-black text-hgray-950 w-full text-[43.5px] text-center flex flex-wrap justify-center">
                      finances and
                      <div className="tool-cont relative flex flex-col items-center">
                        <img
                          className={`mx-2 cursor-pointer ${
                            isMobile ? "w-[62px]" : "w-[72px] mt-[10px]"
                          }`}
                          src="/assets/user3.svg"
                          alt="third user"
                        />
                        <span
                          className={`tooltip-text absolute left-1/2 transform -bottom-12 text-white text-[12.5px] font-normal font-ibm rounded ${
                            isMobile
                              ? "px-1 -translate-x-[84%]"
                              : "px-2 -translate-x-1/2"
                          } py-1 opacity-0 transition-opacity duration-300 pointer-events-none`}
                        >
                          Shiga has been a game-changer for managing our
                          liquidity as a business, especially in the volatile FX
                          market. Relying on a system that essentially automates
                          monthly payments has given us peace of mind.
                        </span>
                      </div>
                      their flexibility
                    </h2>
                  </div>

                  <img
                    className="-ml-[9.2rem] mt-[40px]"
                    src="/assets/pointer.svg"
                    alt="try to hover"
                  />
                </div>

                <div
                  onClick={handleCommunityButtonClick}
                  className="mt-[40px] w-full flex justify-center"
                >
                  <button className="bg-hbrand-600 rounded-[8px] py-[12px] px-[18px] text-white text-[16px] leading-[24px] font-[600] font-ibm">
                    Join Our Community
                  </button>
                </div>
              </div>

              <div className="relative bg-white">
                <div className={`py-[120px] mdxl:pt-[60px] mdxl:pb-[77px]`}>
                  <h2 className="faq-header font-satoshi font-black text-hgray-950 text-[43.5px] text-start">
                    FAQ
                  </h2>
                  <div
                    className={`w-full flex items-start justify-between flex-wrap mt-6 mdxl:flex-col`}
                  >
                    {/* First Column of FAQs */}
                    <div
                      className={`flex flex-col items-start justify-center w-[48%] mdxl:w-full `}
                    >
                      <Accordion item={faqContent1} />
                    </div>

                    {/* Second Column of FAQs */}
                    <div
                      className={`flex flex-col items-start justify-center w-[48%] mdxl:w-full`}
                    >
                      <Accordion item={faqContent2} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <NewsletterModal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
        /> */}
        <div>
          <NewsletterCTA />
        </div>
        <section className=" w-full h-full bg-hbrand-25">
          <div className="max-content">
            <div className="container">
              <div className="relative bg-hbrand-25">
                <div
                  className={` pb-[17rem] pt-[100px] mdxl:pb-[22rem] mdxl:pt-[60px]`}
                >
                  <h2 className="case-header font-satoshi font-black text-hgray-950 text-[43.5px] text-center">
                    Case studies
                  </h2>
                  <p className="font-ibm text-[16px] font-normal text-htext-subdued text-center mt-1">
                    How businesses and individuals use Shiga
                  </p>

                  <div
                    className={`w-full flex items-center justify-center mt-[40px] gap-x-6 flex-wrap gap-y-6  ${
                      isMobile ? "flex-col gap-y-6" : ""
                    } `}
                  >
                    <Link to="/case-study/do-business-in-africa-without-an-african-bank-account">
                      <div className=" flex items-center sm:flex-col sm:gap-2 p-[18px] w-[366px] sm:w-full bg-white rounded-[10px] shadow-s-thick gap-x-3 cursor-pointer hover:scale-95">
                        <img
                          className="w-[71px] sm:w-[50px]"
                          src="/assets/case.svg"
                          alt="case1"
                        />
                        <p className="font-satoshi font-black text-[15.5px] text-[#222] w-[220px]">
                          Do Business in Africa without an African Bank Account.
                        </p>
                      </div>
                    </Link>

                    <Link to="/case-study/protect-your-wealth-from-local-currency-devaluation-by-using-stablecoins">
                      <div className=" flex items-center sm:flex-col sm:gap-2 p-[18px] w-[366px] sm:w-full bg-white rounded-[10px] shadow-s-thick gap-x-3 cursor-pointer hover:scale-95">
                        <img
                          className="w-[71px] sm:w-[50px]"
                          src="/assets/case.svg"
                          alt="case1"
                        />
                        <p className="font-satoshi font-black text-[15.5px] text-[#222] w-[230px]">
                          Protect your wealth from local currency devaluation by
                          using stablecoins.
                        </p>
                      </div>
                    </Link>
                    <Link to="/case-study/accept-crypto-as-a-payment-method-without-knowing-anything-about-crypto">
                      <div className=" flex items-center sm:flex-col sm:gap-2 p-[18px] w-[366px] sm:w-full bg-white rounded-[10px] shadow-s-thick gap-x-3 cursor-pointer hover:scale-95">
                        <img
                          className="w-[71px] sm:w-[50px]"
                          src="/assets/case.svg"
                          alt="case1"
                        />
                        <p className="font-satoshi font-black text-[15.5px] text-[#222] w-[210px]">
                          Accept crypto as a payment method without knowing
                          anything about crypto.
                        </p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
